import React, { useEffect } from "react";
import { MapContainer, TileLayer, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import h337 from "heatmap.js";
import { Bar, Pie } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend } from "chart.js";
import "../styles/LiveCharts.css"; // Separate CSS for styling

ChartJS.register(CategoryScale, LinearScale, BarElement, ArcElement, Tooltip, Legend);

// 🔹 Heatmap Component
const HeatmapLayer = ({ data }) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    const heatmapInstance = h337.create({
      container: map.getContainer(),
      radius: 30,
      maxOpacity: 0.6,
      blur: 0.85,
      gradient: { 0.3: "blue", 0.5: "lime", 0.7: "yellow", 1.0: "red" },
    });

    const heatmapData = {
      max: 10,
      data: data.map(([lat, lng, value]) => ({
        x: map.latLngToContainerPoint([lat, lng]).x,
        y: map.latLngToContainerPoint([lat, lng]).y,
        value,
      })),
    };

    heatmapInstance.setData(heatmapData);

    return () => heatmapInstance.setData({ max: 0, data: [] });
  }, [map, data]);

  return null;
};

// 🔹 Sample Heatmap Data
const heatmapData = [
  [18.5204, 73.8567, 8], // Pune
  [18.5300, 73.8500, 10], // Akurdi
  [18.5150, 73.8550, 5], // Nearby
];

// 🔹 Water Supply Data (Bar Chart)
const barChartData = {
  labels: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  datasets: [
    {
      label: "Water Supply (Liters)",
      data: [3000, 4000, 5000, 4500, 8000, 7000],
      backgroundColor: "#007bff",
    },
  ],
};

// 🔹 Water Shortage (Pie Chart)
const pieChartData = {
  labels: ["Sufficient Supply", "Water Shortage"],
  datasets: [
    {
      data: [55, 45],
      backgroundColor: ["#28a745", "#ff4d4d"],
    },
  ],
};

// 🔹 Main Component
const LiveCharts = () => {
  return (
    <div className="dashboard-grid">
      {/* 🔹 Water Usage Heatmap */}
      <div className="water-usage-container">
        <h2>Water Usage Heatmap</h2>
        <MapContainer center={[18.5204, 73.8567]} zoom={13} className="map-container">
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <HeatmapLayer data={heatmapData} />
        </MapContainer>
      </div>

      {/* 🔹 Water Supply Status */}
      <div className="water-supply-container">
        <h2>Water Supply Status</h2>
        <Bar data={barChartData} />
        <Pie data={pieChartData} />
      </div>
    </div>
  );
};

export default LiveCharts;
